import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import { Toast } from 'vant'
import 'vant/lib/index.css'
import 'vant/lib/icon/local.css';
import './icons' // icon
import '@vant/touch-emulator'
Vue.use(Vant)

Toast.setDefaultOptions('loading', {
  forbidClick: true
})

Vue.config.productionTip = false

if (process.env.NODE_ENV == 'development') {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
}

Vue.prototype.$wx = typeof wx !== 'undefined' ? wx : {}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')